export default "__VITE_ASSET__cf3215ad__"